<div class="box-theme">
  <div class="head">
    <div class="header">
      <div class="ico">
        <img src="./assets/img/icon-11.png" alt="Paga tu cuenta Metrogas">
      </div>
    </div>
    <div class="body">
      <h1>Paga tu cuenta Metrogas</h1>
      <p></p>
    </div>
  </div>
  <div class="body">
    <div class="div-linea-titulo">
      <div class="linea-titulo"></div>
    </div>
  </div>
  <div class="body">
    <div class="header">
      <h2>
        En Metrogas seguimos fortaleciendo la seguridad de tus datos y de tus transacciones. Por eso, para pagar tu
        boleta de forma segura,
        primero debes registrarte o iniciar sesión en nuestra Sucursal Virtual o en la App Mi Metrogas.
        Te explicamos, paso a paso, cómo crear tu cuenta, acceder a tu información y realizar el pago de tu boleta.
      </h2>
    </div>
    <div class="body">
      <div class="row">
        <div class="cont-texto">
          <div>
            <div class="numero">1</div>
            <div class="contenido">Ingresa a metrogas.cl y selecciona la opción Sucursal Virtual. También puedes acceder
              desde la App Mi Metrogas.</div>
          </div>
        </div>
        <div class="imagen">
          <img src="./assets/img/paga-tu-cuenta-01.png" alt="Ingresa a metrogas.cl y selecciona la opción Sucursal Virtual. También puedes acceder
              desde la App Mi Metrogas.">
        </div>
      </div>
      <div class="row">
        <div class="cont-texto">
          <div>
            <div class="numero">2</div>
            <div class="contenido">Si ya tienes una cuenta, ingresa con tu correo registrado y contraseña. Si aún no
              estás registrado, selecciona “Soy nuevo y no tengo usuario”.</div>
          </div>
        </div>
        <div class="imagen">
          <img src="./assets/img/paga-tu-cuenta-02a.png"
            alt="Si ya tienes una cuenta, ingresa con tu correo registrado y contraseña.">
          <img src="./assets/img/paga-tu-cuenta-02b.png"
            alt="Si aún no estás registrado, selecciona “Soy nuevo y no tengo usuario”">
        </div>
      </div>
      <div class="row">
        <div class="cont-texto">
          <div>
            <div class="numero">3</div>
            <div class="contenido">Completa los datos solicitados para crear tu cuenta y acepta las políticas de
              privacidad.</div>
          </div>
        </div>
        <div class="imagen">
          <img src="./assets/img/paga-tu-cuenta-03.png"
            alt="Completa los datos solicitados para crear tu cuenta y acepta las políticas de privacidad.">
        </div>
      </div>
      <div class="row">
        <div class="cont-texto">
          <div>
            <div class="numero">4</div>
            <div class="contenido">Revisa tu correo electrónico e ingresa el código de verificación que recibirás para
              confirmar tu registro.</div>
          </div>
        </div>
        <div class="imagen">
          <img src="./assets/img/paga-tu-cuenta-04.png"
            alt="Revisa tu correo electrónico e ingresa el código de verificación que recibirás para confirmar tu registro.">
        </div>
      </div>
      <div class="row">
        <div class="cont-texto">
          <div>
            <div class="numero">5</div>
            <div class="contenido">Una vez dentro de tu cuenta, revisa tu información y selecciona la opción de pago
              disponible para continuar con el proceso.</div>
          </div>
        </div>
        <div class="imagen">
          <img src="./assets/img/paga-tu-cuenta-05.png"
            alt="Una vez dentro de tu cuenta, revisa tu información y selecciona la opción de pago disponible para continuar con el proceso.">
        </div>
      </div>
      <h2>
        Importante: Para registrarte, debes tener a mano el número de cualquiera de las últimas 3 boletas o facturas
        emitidas. Si no cuentas con esta información, puedes contactarnos a través de nuestros canales oficiales y redes
        sociales. Con gusto te ayudaremos. Una vez completado el registro, podrás ingresar a tu cuenta Metrogas y pagar
        esta boleta, y las próximas, de forma simple y segura.
      </h2>
      <h3 style="text-align: center;">Conoce más de la Sucursal Virtual en este video:</h3>
      <div class="youtube-container">
        <iframe src="https://www.youtube.com/embed/SOLCmrS0sOU" title="Conoce más de la Sucursal Virtual"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowfullscreen>
        </iframe>
      </div>
      <div class="footer">
        <div class="callToAcction">
          <input type="button" value="VOLVER" class="btn btn-volver" [routerLink]="['/home']">
        </div>
      </div>
    </div>
  </div>